import { SessionRequest } from './messages/session-request';
export class ServerSessionProxy {
    webSocketClient;
    sessionServiceDestinationPath;
    constructor(fsId, webSocketClient) {
        this.webSocketClient = webSocketClient;
        this.sessionServiceDestinationPath = `/${fsId}/SessionService`;
    }
    async getSessionToken(filespaceToken) {
        const req = new SessionRequest(filespaceToken, this.sessionServiceDestinationPath);
        const result = (await this.webSocketClient.sendRequest(req, undefined));
        return result.result;
    }
}
